import Vue from 'vue'
import App from './App.vue'
import store from './store/index.js'
import router from './router'
import './plugins/element.js'
import './assets/iconfont/iconfont.css'
import './assets/global.css' // 引入全局样式
import moment from 'moment'
import VueRouter from 'vue-router'
import xcUtils from './utils/xcUtils'
import curUtils from './utils/curUtils'
import userInfo from './utils/userInfo'
import chnEngPublicRequest from './utils/chnEngPublicRequest'
import upLoadFileRequest from './utils/upLoadFileRequest'
import chnEngStatusCode from './utils/chnEngStatusCode'
import echarts from 'echarts'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import './style/common.less'
import http from './http/request'
import env from './http/env'
import downLoadFile from './utils/downLoadFile'
import cebsbLoading from '@/components/cebsbLoading/index.js'
import './utils/directive'
// 按钮组件 全局使用
// import qxButton from '@/permission/qxButton.vue'
// import gameStageBackview from '@/permission/gameStageBackview.vue'
// import gameToolBackView from '@/permission/gameToolBackView.vue'
// import gameTransactionBackview from '@/permission/gameTransactionBackview.vue'
// Vue.component('qxButton', qxButton)
// Vue.component('gameStageBackview', gameStageBackview)
// Vue.component('gameToolBackView', gameToolBackView)
// Vue.component('gameTransactionBackview', gameTransactionBackview)

import raceSchedule from '@/components/auth/raceSchedule.vue'
import tool from '@/components/auth/tool.vue'
import todo from '@/components/auth/todo.vue'
import system from '@/components/auth/system.vue'
import customConfirm from './components/customConfirm.vue'

Vue.component('raceSchedule', raceSchedule)
Vue.component('tool', tool)
Vue.component('todo', todo)
Vue.component('system', system)
Vue.component('customConfirm', customConfirm)
Vue.component('store', store)

Vue.use(cebsbLoading)
NProgress.configure({
  easing: 'ease',
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3
})
// 路由监听
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

// 路由跳转结束
router.afterEach(() => {
  // console.log('路由跳转结束')
  // 防止刷新页面默认赛季丢失
  if (!chnEngStatusCode.defaultSeason && localStorage.getItem('SEASON_1')) {
    chnEngStatusCode.defaultSeason = localStorage.getItem('SEASON_1')
  }
  NProgress.done()
})
Vue.prototype.$xcUtils = xcUtils
Vue.prototype.$curUtils = curUtils
Vue.prototype.$userInfo = userInfo
Vue.prototype.$chnEngPublicRequest = chnEngPublicRequest
Vue.prototype.$upLoadFileRequest = upLoadFileRequest
Vue.prototype.$chnEngStatusCode = chnEngStatusCode
Vue.prototype.$http = http
Vue.prototype.$env = env
Vue.prototype.$downLoadFile = downLoadFile
Vue.prototype.$echarts = echarts
moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
